type SidebarLink = {
  name: string;
  href: string;
};

export function getDataLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("data.data.timesheets"),
      href: `/${locale}/data/timesheets`,
    },
    {
      name: t("data.data.extended-timesheets"),
      href: `/${locale}/data/extended-timesheets`,
    },
    {
      name: t("data.data.worker-timesheets"),
      href: `/${locale}/data/worker-timesheets`,
    },
    {
      name: t("data.data.extended-worker-timesheets"),
      href: `/${locale}/data/extended-worker-timesheets`,
    },
    {
      name: t("data.data.temporary-timesheets"),
      href: `/${locale}/data/temporary-timesheets`,
    },
  ];
}

export function getPieceworkDataLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("data.piecework.team-incomes"),
      href: `/${locale}/data/team-incomes`,
    },
    {
      name: t("data.piecework.acceptance-reports"),
      href: `/${locale}/data/acceptance-reports`,
    },
    {
      name: t("data.piecework.acceptance-report-details"),
      href: `/${locale}/data/acceptance-report-details`,
    },
    {
      name: t("data.piecework.labor-orders"),
      href: `/${locale}/data/labor-orders`,
    },
    {
      name: t("data.piecework.worker-grade-coefficients"),
      href: `/${locale}/data/worker-grade-coefficients`,
    },
    {
      name: t("data.piecework.employee-piecework-incomes"),
      href: `/${locale}/data/employee-piecework-incomes`,
    },
    {
      name: t("data.piecework.piecework-unit-prices"),
      href: `/${locale}/data/piecework-unit-prices`,
    },
  ];
}

export function getHrOrganizationLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("hr.organization.employees"),
      href: `/${locale}/organization/employees`,
    },
    {
      name: t("hr.organization.temporary-workers"),
      href: `/${locale}/organization/temporary-workers`,
    },
    {
      name: t("hr.organization.departments"),
      href: `/${locale}/organization/departments`,
    },
    {
      name: t("hr.organization.branches"),
      href: `/${locale}/organization/branches`,
    },
    {
      name: t("hr.organization.boards"),
      href: `/${locale}/organization/boards`,
    },
    {
      name: t("hr.organization.production-units"),
      href: `/${locale}/organization/production-units`,
    },
  ];
}

export function getHrPayrollLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("hr.payroll.payroll-items"),
      href: `/${locale}/payroll/payroll-items`,
    },
    {
      name: t("hr.payroll.salary-calculation-rules"),
      href: `/${locale}/payroll/salary-calculation-rules`,
    },
    {
      name: t("hr.payroll.profiles"),
      href: `/${locale}/payroll/profiles`,
    },
    {
      name: t("hr.payroll.worker-profiles"),
      href: `/${locale}/payroll/worker-profiles`,
    },
    {
      name: t("hr.payroll.temporary-profiles"),
      href: `/${locale}/payroll/temporary-profiles`,
    },
    {
      name: t("hr.payroll.payroll-parameters"),
      href: `/${locale}/payroll/payroll-parameters`,
    },
    {
      name: t("hr.payroll.queries"),
      href: `/${locale}/payroll/queries`,
    },
    {
      name: t("hr.payroll.reports"),
      href: `/${locale}/payroll/reports`,
    },
  ];
}

export function getApprovalLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("approvals.pending"),
      href: `/${locale}/payroll/approval-tickets/pending`,
    },
  ];
}

export function getTicketCreationLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("approvals.tickets-office"),
      href: `/${locale}/payroll/approval-tickets/office`,
    },
    {
      name: t("approvals.tickets-worker"),
      href: `/${locale}/payroll/approval-tickets/worker`,
    },
    {
      name: t("approvals.tickets-temporary"),
      href: `/${locale}/payroll/approval-tickets/temporary`,
    },
  ];
}

export function getHrReportLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("hr.reports.timesheets"),
      href: `/${locale}/reports/timesheets`,
    },
    {
      name: t("hr.reports.worker-timesheets"),
      href: `/${locale}/reports/worker-timesheets`,
    },
    {
      name: t("hr.reports.temporary-timesheets"),
      href: `/${locale}/reports/temporary-timesheets`,
    },
    {
      name: t("hr.reports.salaries"),
      href: `/${locale}/reports/salaries`,
    },
    {
      name: t("hr.reports.worker-salaries"),
      href: `/${locale}/reports/worker-salaries`,
    },
    {
      name: t("hr.reports.temporary-salaries"),
      href: `/${locale}/reports/temporary-salaries`,
    },
    {
      name: t("hr.reports.advance-limits"),
      href: `/${locale}/reports/advance-limits`,
    },
    {
      name: t("hr.reports.team-incomes"),
      href: `/${locale}/reports/team-incomes`,
    },
    {
      name: t("hr.reports.piecework-payment-allocations"),
      href: `/${locale}/reports/piecework-payment-allocations`,
    },
    {
      name: t("hr.reports.bank-transfer-sheets"),
      href: `/${locale}/reports/bank-transfer-sheets`,
    },
    {
      name: t("hr.reports.issue-payslips"),
      href: `/${locale}/reports/issue-payslips`,
    },
    {
      name: t("hr.reports.salary-reports"),
      href: `/${locale}/reports/salary-reports`,
    },
    {
      name: t("hr.reports.worker-salary-reports"),
      href: `/${locale}/reports/worker-salary-reports`,
    },
    {
      name: t("hr.reports.company-wide-salary-reports"),
      href: `/${locale}/reports/company-wide-salary-reports`,
    },
    {
      name: t("hr.reports.company-wide-temporary-salary-reports"),
      href: `/${locale}/reports/company-wide-temporary-salary-reports`,
    },
    {
      name: t("hr.reports.monthly-salary-comparisons"),
      href: `/${locale}/reports/monthly-salary-comparisons`,
    },
    {
      name: t("hr.reports.taxes"),
      href: `/${locale}/reports/taxes`,
    },
  ];
}

export function getHrToolLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("tools.salary-backups"),
      href: `/${locale}/tools/salary-backups`,
    },
  ];
}

export function getMasterDataPolicyLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("master-data.policies.minimum-wages"),
      href: `/${locale}/policies/minimum-wages`,
    },
    {
      name: t("master-data.policies.tax-schedules"),
      href: `/${locale}/policies/tax-schedules`,
    },
    {
      name: t("master-data.policies.salary-scales"),
      href: `/${locale}/policies/salary-scales`,
    },
    {
      name: t("master-data.policies.worker-salary-grades"),
      href: `/${locale}/policies/worker-salary-grades`,
    },
  ];
}

export function getMasterDataPrivilegeLinks(
  t: (key: string) => string,
  locale: string
): SidebarLink[] {
  return [
    {
      name: t("master-data.privileges.resources"),
      href: `/${locale}/privileges/resources`,
    },
    {
      name: t("master-data.privileges.roles"),
      href: `/${locale}/privileges/roles`,
    },
    {
      name: t("master-data.privileges.user-roles"),
      href: `/${locale}/privileges/user-roles`,
    },
    {
      name: t("master-data.privileges.users"),
      href: `/${locale}/privileges/users`,
    },
    {
      name: t("master-data.privileges.approval-processes"),
      href: `/${locale}/privileges/approval-processes`,
    },
  ];
}
